import React from 'react';

export default function NotFound() {
    return (
        <main class="h-screen w-full flex flex-col justify-center items-center bg-primary text-primary-content">
            <h1 class="text-9xl font-extrabold tracking-widest">404</h1>
            <div class="bg-secondary text-secondary-content px-2 text-lg rounded rotate-12 absolute">
                Template Not Found
            </div>
        </main>
    )
}
